import React from "react";
import { Link } from "react-router-dom";
import Page from "../components/Page";
import { useLang } from "../i18n/LanguageContext";
import usePageMeta from "../hooks/usePageMeta";

export default function Terms() {
  const { lang } = useLang();
  const sq = lang === "sq";
  usePageMeta(sq ? "Kushtet e përdorimit — Amora Weddings" : "Terms of Service — Amora Weddings");

  return (
    <Page title={sq ? "Kushtet e përdorimit" : "Terms of Service"} narrow>
      <p className="updated">{sq ? "Përditësuar së fundi: 2026" : "Last updated: 2026"}</p>

      {sq ? (
        <>
          <h2>1. Pranimi i kushteve</h2>
          <p>Duke përdorur Amora Weddings ("platforma"), ti pranon këto kushte. Nëse nuk pajtohesh, të lutemi mos e përdor platformën.</p>

          <h2>2. Çfarë është Amora Weddings</h2>
          <p>Amora Weddings është një platformë që lidh çiftet me biznese të dasmave. Ne nuk ofrojmë vetë shërbimet e dasmës dhe nuk jemi palë në marrëveshjen mes çiftit dhe biznesit. Çdo marrëveshje, pagesë dhe shërbim bëhet drejtpërdrejt mes tyre.</p>

          <h2>3. Llogaritë</h2>
          <p>Bizneset krijojnë një llogari për të menaxhuar listimin e tyre. Je përgjegjës për ruajtjen e fjalëkalimit dhe për gjithçka që ndodh nën llogarinë tënde. Të dhënat që jep duhet të jenë të sakta.</p>

          <h2>4. Listimet dhe përmbajtja</h2>
          <p>Ti mbetesh pronar i fotove dhe përmbajtjes që ngarkon, por na jep të drejtën t'i shfaqim në platformë. Përmbajtja nuk duhet të jetë mashtruese, e paligjshme ose e të tjerëve pa leje. Ne mund të heqim çdo listim që shkel këto kushte.</p>

          <h2>5. Abonimet dhe pagesat</h2>
          <p>Bizneset paguajnë një tarifë mujore sipas planit të zgjedhur. Pagesa bëhet drejtpërdrejt me ne dhe listimi aktivizohet pas konfirmimit. Tarifat nuk rimbursohen për periudha të papërdorura, përveç kur kërkohet me ligj.</p>

          <h2>6. Promovimet</h2>
          <p>Promovimet (boost) janë opsionale dhe i japin listimit tënd përparësi për një kohë të kufizuar. Vendet janë të kufizuara dhe ndahen sipas radhës dhe ditëve të blera.</p>

          <h2>7. Përgjegjësia</h2>
          <p>Amora Weddings nuk garanton cilësinë, disponueshmërinë ose sjelljen e asnjë biznesi të listuar, dhe nuk mban përgjegjësi për mosmarrëveshjet mes çifteve dhe bizneseve. Platforma ofrohet "ashtu siç është".</p>

          <h2>8. Ndalimet</h2>
          <p>Ndalohet përdorimi i platformës për spam, mashtrim, përmbajtje të paligjshme, ose çdo veprim që dëmton platformën apo përdoruesit e tjerë.</p>

          <h2>9. Ndryshimet</h2>
          <p>Mund t'i përditësojmë këto kushte herë pas here. Përdorimi i vazhdueshëm nënkupton pranimin e versionit të ri.</p>

          <h2>10. Ligji</h2>
          <p>Këto kushte rregullohen nga ligjet e Republikës së Kosovës.</p>

          <h2>11. Kontakti</h2>
          <p>Për çdo pyetje, <Link to="/contact">na kontakto</Link>.</p>
        </>
      ) : (
        <>
          <h2>1. Acceptance of terms</h2>
          <p>By using Amora Weddings (the "platform"), you agree to these terms. If you do not agree, please do not use the platform.</p>

          <h2>2. What Amora Weddings is</h2>
          <p>Amora Weddings is a platform that connects couples with wedding businesses. We do not provide the wedding services ourselves and are not a party to the agreement between a couple and a business. All arrangements, payments and services happen directly between them.</p>

          <h2>3. Accounts</h2>
          <p>Businesses create an account to manage their listing. You are responsible for keeping your password safe and for everything that happens under your account. The information you provide must be accurate.</p>

          <h2>4. Listings and content</h2>
          <p>You keep ownership of the photos and content you upload, but you grant us the right to display them on the platform. Content must not be misleading, unlawful, or belong to others without permission. We may remove any listing that breaks these terms.</p>

          <h2>5. Subscriptions and payments</h2>
          <p>Businesses pay a monthly fee based on the chosen plan. Payment is made directly with us and the listing is activated after confirmation. Fees are non-refundable for unused periods, except where required by law.</p>

          <h2>6. Boosts</h2>
          <p>Boosts are optional and give your listing priority placement for a limited time. Spots are limited and allocated based on order and days purchased.</p>

          <h2>7. Responsibility</h2>
          <p>Amora Weddings does not guarantee the quality, availability or conduct of any listed business, and is not responsible for disputes between couples and businesses. The platform is provided "as is".</p>

          <h2>8. Prohibited use</h2>
          <p>You may not use the platform for spam, fraud, unlawful content, or any action that harms the platform or other users.</p>

          <h2>9. Changes</h2>
          <p>We may update these terms from time to time. Continued use means you accept the new version.</p>

          <h2>10. Governing law</h2>
          <p>These terms are governed by the laws of the Republic of Kosovo.</p>

          <h2>11. Contact</h2>
          <p>For any questions, <Link to="/contact">contact us</Link>.</p>
        </>
      )}
    </Page>
  );
}
